<template>
  <div
    :class="type === 'total' ? 'total-price' : 'list-total'"
    class="grid-string grid-string-data"
  >
    <template v-for="field in fields">
      <component
        :is="field.component"
        :key="field.slug + field.upd"
        v-bind="field.props"
        v-on="field.events"
      />
    </template>
  </div>
</template>

<script>
  import EmptyCell from '@/components/project/list/EmptyCell';
  import TotalName from '@/components/project/list/TotalName';
  import NumberCell from '@/components/common/NumberCell';
  import RowMixin from '@/components/common/RowMixin';

  /**
   * Fast go to:
   * – {@link index_column} – first column with actions in form of icons
   * – {@link name_column} – the text to display in the second column
   * – {@link number_column} – amounts of total costs
   * – {@link empty_column} – empty is a cell that takes space of many cells
   */

  export default {
    name: 'TotalRow',
    mixins: [RowMixin],

    props: {
      type: {
        type: String,
        default: 'total',
        validator: (val) => ['total', 'subtotal'].includes(val),
      },

      editable: {
        type: Boolean,
        required: true,
      },

      currency: {
        type: String,
        default: null,
      },
    },

    data() {
      return {
        COMPONENTS: {
          /** @name index_column */
          index: {
            component: EmptyCell,
            props: () => ({
              class: 'cell-id cell-id-icons',
            }),
            events: () => ({}),
          },

          /** @name name_column */
          name: {
            component: TotalName,
            props: () => {
              const isTotal = this.type === 'total';
              return {
                label: isTotal ? this.$t('Total price') : this.$t('Subtotal'),
                newLabel: this.editable && !isTotal ? this.$t('Add parameters') : '',
                isPurple: isTotal,
              };
            },
            events: () => ({
              add: () => this.$emit('add'),
            }),
          },

          /** @name number_column */
          number: {
            component: NumberCell,
            props: (field) => ({
              currency: this.currency,
              label: this.data[field.slug] || 0,
            }),
            events: () => ({}),
          },

          /** @name empty_column */
          empty: {
            component: EmptyCell,
            props: () => ({
              class: 'no-border',
            }),
            events: () => ({}),
          },
        },
      };
    },
  };
</script>
